import React from 'react';

const OrderCard = ({ order, onMarkClick }) => {
  const statusMap = {
    issued: { label: 'Pending', color: 'bg-yellow-100 text-yellow-900' },
    called: { label: 'Called', color: 'bg-sky-100 text-sky-900' },
    ready: { label: 'Ready', color: 'bg-emerald-100 text-emerald-900' }
  };

  const status = statusMap[order.status] || { label: 'Pending', color: 'bg-slate-100 text-slate-900' };

  const displayToken = order.token || order.token_no || order.token_number || order.tokenId || '---';

  return (
    <div className="rounded-3xl border border-gray-200 bg-white p-5 shadow-sm">
      <div className="mb-4 flex items-start justify-between">
        <div>
          <div className="text-xs uppercase tracking-[0.24em] text-slate-500">Token</div>
          <div className="mt-2 text-5xl font-extrabold text-slate-900 leading-none">{displayToken}</div>
        </div>
        <div className="mb-5 rounded-xl py-2 bg-slate-100 px-4 text-sm text-slate-700">
          <div className="text-lg font-semibold text-slate-900">{order.time}</div>
        </div>
      </div>

      <div className="mb-4">
        <div className="text-sm font-semibold text-slate-700 mb-3">Ordered items</div>
        <div className="space-y-2 h-64 overflow-y-auto pr-1">
          {order.items.map((item, index) => (
            <div key={index} className="flex items-center text-lg justify-between rounded-2xl bg-slate-50 px-4 py-3 font-medium text-slate-900">
              <span>{item.name}</span>
              <span className="text-slate-600 text-lg">{item.quantity}</span>
            </div>
          ))}
        </div>
      </div>

      <button
        onClick={() => onMarkClick(order.id)}
        className="w-full rounded-3xl bg-slate-900 px-4 py-4 text-base font-semibold text-white shadow-lg shadow-slate-200 transition hover:bg-slate-800 focus:outline-none focus:ring-2 focus:ring-slate-500"
      >
        Confirm Order
      </button>
    </div>
  );
};

export default OrderCard;
